/**
 * Tracker class, needs to implement the following interface:
 * class AnalyticsTracker{
 *      constructor(settings){};
 *      trackPageView(details={}){};
 *      trackEvent(details={}){};
 *      remove(){};
 * }
 * After the tracker is created it can be added to the Analytics class. You can trigger all events through
 * the Analytics class too. That way all trackers will be targetted.
 */
class AnalyticsGoogle {
    static isLibraryLoaded = false;

    static gtag(){
        // Google Analytics needs to have this as an Argument instance, a normal array doesn't work.
        /* eslint-disable-next-line */
        window['dataLayer'].push(arguments);
    };

    /**
     * Loading the Google Analytics library
     */
    static loadLibrary(trackerId){
        AnalyticsGoogle.isLibraryLoaded = true;
        // Set initial gt.ag/js?id=<first ID> script to <head>
        // NOTE: gtag script only needs to be set to page once, but each gtag('config', <ID>) that's pushed to
        // the dataLayer will add subsequent gtag/js?id=<ID> scripts to the page
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.src = 'https://www.googletagmanager.com/gtag/js?id=' + trackerId;
        document.getElementsByTagName('head')[0].appendChild(script);
        window['dataLayer'] = window['dataLayer'] || [];
        AnalyticsGoogle.gtag('js', new Date());
    }

    constructor(settings){
        this.trackerId = settings.trackerId;
        if(! AnalyticsGoogle.isLibraryLoaded){
            AnalyticsGoogle.loadLibrary(this.trackerId);
        }
        this.init(this.trackerId);
    }

    // Initializing this tracker
    init(trackerId){
        delete window['ga-disable-' + trackerId];
        AnalyticsGoogle.gtag('config', trackerId, {
            send_page_view: false
        });
    }

    // sending a page view
    trackPageView(settings = {}){
        AnalyticsGoogle.gtag('event', 'page_view',
                {
                    page_title: settings.title,
                    page_location: settings.location,
                    page_path: settings.path,
                    send_to: this.trackerId
                });
    }

    // sending an event. Google analytics supports category, action and label as values in settings
    trackEvent(settings){
        AnalyticsGoogle.gtag('event', settings.action,
                {
                    event_category: settings.category,
                    event_label: settings.label,
                    value: settings.value,
                    send_to: this.trackerId
                });
    }

    remove(){
        window['ga-disable-' + this.trackerId] = true;
    }
}

export {AnalyticsGoogle};
